import { Component, Renderer2, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { GenericModalService, ModalSettingsMessage } from '../shared/generic-modal/generic-modal.service';
import { ToastService, ToastType } from '../shared/toast/toast.service';
import { PartnerService } from './services/partner.service';
import { Partner } from './models/partner';
import { PartnerType } from './models/partner-type';
import { PartnerComponentBase } from './partner-search-details.base';
import { FormsModule } from '@angular/forms';

import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';

@Component({
    templateUrl: './partner-search-details-general.component.html',
    selector: 'ep-partner-details-general',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, PermissionRequiredDirective]
})

export class PartnerSearchDetailsGeneralComponent extends PartnerComponentBase {
    private partnerService = inject(PartnerService);
    private toastService = inject(ToastService);
    private modalService = inject(GenericModalService);
    private loadingPanelService = inject(LoadingPanelService);
    private renderer = inject(Renderer2);

    public partnerTypes: PartnerType[] = [];
    public clonedPartner: Partner = null;
    public isEditing: boolean = false;

    async partnerSet(): Promise<void> {
        this.partnerTypes = await this.partnerService.getPartnerTypes();
        this.clonePartner();
    }

    clonePartner() {
        this.clonedPartner = Object.assign({}, this.selectedPartner);
        this.clonedPartner.PartnerType = this.partnerTypes.find(pt => pt.Id === this.clonedPartner.PartnerType?.Id);
    }

    edit() {
        this.setEditMode(true);
        this.isEditing = true;
    }

    cancel() {
        this.clonePartner();
        this.setEditMode(false);
        this.isEditing = false;
    }

    save() {
        if (this.selectedPartner.PartnerName != this.clonedPartner.PartnerName) {
            this.checkPartnerExist();
        }
        else {
            this.savePartner();
        }
    }

    checkPartnerExist() {
        this.partnerService.isPartnerNameAvailable(this.clonedPartner.PartnerName).then((isAvailable: boolean) => {
            if (isAvailable) {
                this.savePartner();
            }
            else {
                let settings = new ModalSettingsMessage('Partner name in use', 'The chosen partner name is not available.');
                this.modalService.message(settings).then((e) => { }).catch((e) => { });
                this.renderer.selectRootElement("#searchDetailsPartnerName").focus();
            }
        });
    }

    savePartner() {

        this.loadingPanelService.showLoadingPanelDirect('Saving partner...');
        this.partnerService.savePartner(this.clonedPartner).then((savedPartner) => {
            Object.assign(this.selectedPartner, savedPartner); // Merge saved partner with selected partner to reflect changes
            super.refreshSearchData();
            this.cancel(); // Let the cancel method do the rest...
            this.loadingPanelService.hideLoadingPanel();
            this.toastService.showToast('Partner saved...', ToastType.success);
        });
    }
}
